"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createClient = void 0;
const uid_js_1 = require("../utils/uid.js");
function createClient({ chain, key = 'base', name = 'Base Client', pollingInterval = 4000, transport, type = 'base', }) {
    const { config, request, value } = transport({ chain, pollingInterval });
    return {
        chain: chain,
        key,
        name,
        pollingInterval,
        request: request,
        transport: { ...config, ...value },
        type,
        uid: (0, uid_js_1.uid)(),
    };
}
exports.createClient = createClient;
//# sourceMappingURL=createClient.js.map